/************************************************************
 External Medication namespace
 ************************************************************/

window.external_medication = {
    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction: function (action, row, callback) {
        this._action = action;
        this._callback = callback;
        this._row = row;

        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        // Cancel
        if (actionId == 3) {
            external_medication.openReason(external_medication.cancelReasonModalHandler);
        }
        // Other actions
        else {
            external_medication.executeGenericAction();
        }
    },
    // Open Reason
    openReason: function (callback) {
        var params = {
            task_id:external_medication._action.task_id,
            wf_id:external_medication._action.wf_id,
            wf_status_id:external_medication._action.to_state_id,
            wf_action_id:external_medication._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();

                external_medication._callback(false, external_medication._action, external_medication._row);
            });
    },
    // Cancel Order
    cancelReasonModalHandler:function (data) {
        $.fancybox.close(true);

        var params = {
            task_id:external_medication._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:external_medication._row.wf_id,
            wf_status_id:external_medication._row.wf_status_id,
            wf_action_id:data.actionId
        };

        $.post('/ambulatory/prescription/cancel_prescription', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();

                    external_medication._callback(false, external_medication._action, external_medication._row);
                } else {
                    external_medication._callback(true, external_medication._action, external_medication._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                external_medication._callback(false, external_medication._action, external_medication._row);
            });
    },
    // Execute Generic Action
    executeGenericAction:function () {
        workflow.executeAction(external_medication._action, external_medication._callback, external_medication._row);
    },

    /*********************************
     * PEM - INIT SCREEN EVENTS
     **********************************/
    clearEventListeners: function(){
        // Clear event listeners
        $("#dci_desc").unbind();
        $('#dci-search').unbind();
        $('#brand_desc').unbind();
        $('#brand-search').unbind();
        $("#product_desc").unbind();
        $('#add-other-prod-ct').unbind();
        $("#product_desc").unbind();
        $("#med_desc").unbind();
        $("#manipulated_desc").unbind();
        $('#manipulated-search').unbind();
        $('#dietetic-search').unbind();
        $('#other-product-search').unbind();

        $('#pharmaceutical_form').unbind();
        $('#dosage').unbind();
        $('#package').unbind();
    },
    onSearchTypeNavClick: function(){
        $('#prescription_outer_ct .search_type_nav .nav-tabs li:not(.active)').click(function(){

            var _menu = $(this).data('menu');

            switch(_menu){
                case 'DCI':
                case 'BRAND':
                    if( typeof(prescription_external_medication_index) !== 'undefined' ){
                        prescription_external_medication_index.currentMedicament
                        Hades.loadPartial('/prescription/external_medication/search_medication_screen', {search_type:_menu}, 'search_medication_outer_ct', prescription_external_medication_index.onSearchScreenLoaded);
                    }else if( typeof(prescription_external_medication_index_dematerialized) !== 'undefined' ){
                        Hades.loadPartial('/prescription/external_medication/search_medication_screen', {search_type:_menu}, 'search_medication_outer_ct', prescription_external_medication_index_dematerialized.onSearchScreenLoaded);
                    }

                    break;
            }
        });
    },

    onSearchTypeBrand: function(){
        $('#brand_desc').keyup(function(evt){

            if( typeof(prescription_external_medication_index) !== 'undefined' ){
                prescription_external_medication_index.updateBrandFields(true);
            }else if( typeof(prescription_external_medication_index_dematerialized) !== 'undefined' ){
                prescription_external_medication_index_dematerialized.updateBrandFields(true);
            }


            /*
             var ctrlDown = evt.ctrlKey||evt.metaKey // Mac support
             if(ctrlDown && evt.keyCode == 32){ //13: enter, 32: space
             $('#brand-search').click();
             }
             */
            if(evt.keyCode == 13){ //13: enter
                $('#brand-search').click();
            }
        });


        $("#brand_desc").autocomplete({
            search: function () {
                Hades.showLoading();
            },
            change: function(ui) {
                if(!ui.item){
                    if( typeof(prescription_external_medication_index) !== 'undefined' ){
                        prescription_external_medication_index.updateBrandFields(true);
                    }else if( typeof(prescription_external_medication_index_dematerialized) !== 'undefined' ){
                        prescription_external_medication_index_dematerialized.updateBrandFields(true);
                    }
                }
            },
            source: function (request, response) {
                $.ajax({
                    url: "/prescription/external_medication/search_brand_ayt",
                    dataType: "jsonp",
                    data: {
                        featureClass: "P",
                        style: "full",
                        maxRows: 300,
                        name_startsWith: request.term
                    },
                    success: function (data) {
                        $("#brand_id").val(null);
                        $("#brand_supplier_id").val(null);

                        Hades.hideLoading();
                        debug.log("Brand_List", data);
                        response($.map(data, function (item) {
                            return {
                                label: item.desc,
                                value: item.pm_desc,
                                package_id: item.package_id,
                                package_supplier_id: item.package_supplier_id,
                                pharm_form_id: item.pharm_form_id,
                                pharm_form_desc: item.pharm_form_desc,
                                strength_id: item.strength_id,
                                strength_desc: item.strength_desc,
                                pkg_size_id: item.pkg_size_id,
                                pkg_size_desc: item.pkg_size_desc,
                                pm_desc: item.pm_desc
                            }
                        }));
                    },
                    error: function (xhr, status, error) {
                        Hades.showError(error, xhr.responseText, xhr, status, error);
                        Hades.hideLoading();
                    }
                });
            },
            minLength: 2,
            select: function (event, ui) {
                debug.log("Select: ",ui);
                if (ui.item) {
                    $("#brand_id").val(ui.item.package_id);
                    $("#brand_supplier_id").val(ui.item.package_supplier_id);

                    if( typeof(prescription_external_medication_index) !== 'undefined' ){
                        prescription_external_medication_index.updateBrandFields(false, ui.item);
                    }else if( typeof(prescription_external_medication_index_dematerialized) !== 'undefined' ){
                        prescription_external_medication_index_dematerialized.updateBrandFields(false, ui.item);
                    }
                }
            },
            open: function () {
                $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
            },
            close: function () {
                $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
            }
        });

        if( typeof(prescription_external_medication_index) !== 'undefined' ){
            $('#brand-search').click(prescription_external_medication_index.searchBrand);
        }else if( typeof(prescription_external_medication_index_dematerialized) !== 'undefined' ){
            $('#brand-search').click(prescription_external_medication_index_dematerialized.searchBrand);
        }
    },

    /*********************************
     * PEM - CARD Events
     **********************************/
    autenticatePersonalCard: function(params, callback,remainInPage){
        Hades.showLoading();
        
            delete $.ajaxSettings.headers["X-CSRF-Token"];
            const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
            $.ajax({
                url: params.url_path,
                type: 'POST',
                crossDomain: true,
                contentType: 'application/x-www-form-urlencoded; charset=utf-8',
                data: $.param(params),
                success: function (data, status, xhr) {
                    $.ajaxSettings.headers["X-CSRF-Token"] = csrfToken;
                    Hades.checkIfUserIsAuthorized(data, status, xhr);
                    external_medication.getSPMSToken(data||{}, callback, remainInPage, params);
                },
                error: function (xhr, status, error) {
                    $.ajaxSettings.headers["X-CSRF-Token"] = csrfToken;
                    Hades.hideLoading();
                    $('#contextual-buttons button.print_btn').attr('disabled', false);
                    $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                    bootbox.alert(GlobalTranslations['APP_LABEL.2316']);
                }
            });
    },
    getSPMSToken: function(card_info, callback, remainInPage, card_request_params){
        // debug.log("getSPMSToken remainInPage", remainInPage);
        // debug.log("getSPMSToken callback", callback);
        // debug.log("getSPMSToken card_info", card_info);
        // debug.log("getSPMSToken card_request_params", card_request_params);

        // debug.log("getSPMSToken card_info init ", card_info);
        var error_msg = '';
        if (card_info != null){
            card_info = JSON.parse(card_info.toString());
        } else {
            error_msg = 'CARD_SERVICE.WARNING.BROKEN_RESPONSE';
        }

        debug.log("getSPMSToken card_info", card_info);

        if (card_info.status == 'error'){
            if (typeof(card_info.data) !== 'undefined'
                && typeof(card_info.data.error_msg) !== 'undefined'
                && card_info.data.error_msg != '')
            {
                if (card_info.data.error_msg == 'Erro não foi possivel gerar assinatura.'){
                    error_msg = GlobalTranslations['CKR_USER_NOT_LOGGED_IN'];
                }else{
                    error_msg = GlobalTranslations[card_info.data.error_msg];
                }
            } else {
                error_msg = GlobalTranslations['CARD_SERVICE.WARNING.CARD_NOT_FOUND'];
            }
        }

        if (error_msg != ''){
            Hades.hideLoading();
            $('#contextual-buttons button.print_btn').attr('disabled', false);
            $('#contextual-buttons button.confirm_btn').attr('disabled', false);
            bootbox.alert(error_msg);
            return;
        }

        // debug.log("getSPMSToken card_info", card_info.data);

        if(card_info.card_type === 'COM' ){
            var certificates = [card_info.data.certificates.certSign, card_info.data.certificates.certSignSubCA];
        }else{ // CC
            var certificates = [card_info.data.certificates.certSign];
        }

        var params = {
            "authType": card_info.card_type,
            "fiscalNumber": (card_info.data.personal_data !== null) ? card_info.data.personal_data.TaxNumber : null,
            "signatureValue": card_info.data.certificates.signature,
            "certificates": certificates
        };

        if(params.authType == "COM")
            params["OrderNumber"] = (typeof(card_info.number) !== 'undefined') ? card_info.number : null

        if(card_info.cardExpirationDate){

            var expirationDate = new Date(card_info.cardExpirationDate)
            var currentDate = new Date()

            if(expirationDate>currentDate){
                $('#contextual-buttons button.print_btn').attr('disabled', false);
                $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                bootbox.alert(GlobalTranslations['CARD_SERVICE.WARNING.EXPIRED_CARD']);
                return
            }
            
        }

        $.post("/prescription/external_medication/get_spms_token", params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success){
                    if(data.token){
                        window.sessionStorage.setItem("SPMS_TOKEN", data.token);
                        window.sessionStorage.setItem("SPMS_CERTIFICATES", params.certificates);
                        window.sessionStorage.setItem("SPMS_SIGNATURE", params.signatureValue);
                        window.sessionStorage.setItem("SPMS_AUTH_TYPE", params.authType);

                        if(remainInPage){
                            $('#contextual-buttons button.print_btn').attr('disabled', false);
                            $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                            Hades.hideLoading();
                            return;
                        } else{
                            if ( typeof(prescription_external_medication_index_dematerialized) !== 'undefined' ){
                                // Already inside prescription RSP Screen
                                $('#contextual-buttons button.print_btn').attr('disabled', false);
                                $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                                Hades.hideLoading();
                            }else{
                                // Not Already inside prescription RSP Screen
                                if (!callback){
                                    external_medication.goToPrescriptionScreen(card_request_params, card_info)
                                } else {
                                    $('#contextual-buttons button.print_btn').attr('disabled', false);
                                    $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                                    callback(card_request_params, card_info)
                                }
                            }
                        }

                    } else if (data.errors && data.errors.erroTipoLista && data.errors.erroTipoLista.descricao){
                        $('#contextual-buttons button.print_btn').attr('disabled', false);
                        $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                        Hades.hideLoading();
                        bootbox.alert(data.errors.erroTipoLista.descricao);
                    } else{
                        $('#contextual-buttons button.print_btn').attr('disabled', false);
                        $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                        Hades.hideLoading();
                        bootbox.alert( GlobalTranslations['APP_LABEL.PEM.SPMS_AUTH_FAIL_TRY_AGAIN'] );
                    }
                } else {
                    $('#contextual-buttons button.print_btn').attr('disabled', false);
                    $('#contextual-buttons button.confirm_btn').attr('disabled', false);

                    Hades.hideLoading();
                    if (data.errors && data.errors.erroTipoLista && data.errors.erroTipoLista.descricao){
                        bootbox.alert(data.errors.erroTipoLista.descricao);
                    }else{
                        bootbox.alert( GlobalTranslations['APP_LABEL.PEM.SPMS_AUTH_FAIL_TRY_AGAIN_IF_FAIL_CALL_ADMIN'] );
                    }
                }

            })
            .fail(function (xhr, status, error) {
                $('#contextual-buttons button.print_btn').attr('disabled', false);
                $('#contextual-buttons button.confirm_btn').attr('disabled', false);

                Hades.hideLoading();

                bootbox.alert(GlobalTranslations['APP_LABEL.PEM.SPMS_AUTH_FAIL']);

            });
    },

    getSPMSTokenCredentials: function(isUE,username,password,remainInPage, callback){
        var params = {
            "authType": "CRED",
            "user": username,
            "password": password,
            "localPrescricao": "",
            "signatureValue":"",
            "certificates": [],
            "financial_institution_id": $('#financial_institution').val()
        }

        var authenticated = null;

        $.post("/prescription/external_medication/get_spms_token", params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success){
                    if(data.token){
                        window.sessionStorage.setItem("SPMS_TOKEN", data.token);
                        window.sessionStorage.setItem("SPMS_AUTH_TYPE", params.authType);
                        params.isUE = isUE;

                        if(remainInPage){
                           //Nothing to do, stay on the same page!
                            $('#contextual-buttons button.print_btn').attr('disabled', false);
                            $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                        }else{
                            if (callback){
                                $('#contextual-buttons button.print_btn').attr('disabled', false);
                                $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                                callback();
                            }else{
                                Hades.loadScreen(external_medication.goToPrescriptionScreenStrategyInfo.screen_path, params);
                                external_medication.goToPrescriptionScreenStrategyInfo = null;
                            }
                        }
                    } else if (data.errors && data.errors.erroTipoLista && data.errors.erroTipoLista.descricao){
                        Hades.hideLoading();
                        $('#contextual-buttons button.print_btn').attr('disabled', false);
                        $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                        bootbox.alert(data.errors.erroTipoLista.descricao);
                    } else{
                        Hades.hideLoading();
                        $('#contextual-buttons button.print_btn').attr('disabled', false);
                        $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                        bootbox.alert( GlobalTranslations['APP_LABEL.PEM.SPMS_AUTH_FAIL_TRY_AGAIN'] );
                    }
                }else{
                    Hades.hideLoading();
                    if (data.errors && data.errors.erroTipoLista && data.errors.erroTipoLista.descricao){
                        $('#contextual-buttons button.print_btn').attr('disabled', false);
                        $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                        bootbox.alert(data.errors.erroTipoLista.descricao);
                    }else{
                        $('#contextual-buttons button.print_btn').attr('disabled', false);
                        $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                        bootbox.alert( GlobalTranslations['APP_LABEL.PEM.SPMS_AUTH_FAIL_TRY_AGAIN_IF_FAIL_CALL_ADMIN'] );
                    }
                }

            })
            .fail(function (xhr, status, error) {
                Hades.hideLoading();
                $('#contextual-buttons button.print_btn').attr('disabled', false);
                $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                bootbox.alert(GlobalTranslations['APP_LABEL.PEM.SPMS_AUTH_FAIL'])
            });

            return authenticated
    },

    validateSPMSToken: function(e,remainInPage){
        var authType = window.sessionStorage.getItem("SPMS_AUTH_TYPE");
        var authToken = window.sessionStorage.getItem("SPMS_TOKEN");

        var params = {
            "authType": window.sessionStorage.getItem("SPMS_AUTH_TYPE"),
            "signatureValue": window.sessionStorage.getItem("SPMS_SIGNATURE"),
            "token": window.sessionStorage.getItem("SPMS_TOKEN")
        }

        return $.post("/prescription/external_medication/validate_spms_token", params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.valid){
                    window.sessionStorage.setItem("SPMS_TOKEN", data.spms_token_info.token)
                }else{
                    window.sessionStorage.removeItem("SPMS_TOKEN")
                    window.sessionStorage.removeItem("SPMS_CERTIFICATES")
                    window.sessionStorage.removeItem("SPMS_SIGNATURE")
                    window.sessionStorage.removeItem("SPMS_AUTH_TYPE")
                }

            })
            .fail(function (xhr, status, error) {
                Hades.hideLoading();

                window.sessionStorage.removeItem("SPMS_TOKEN")
                window.sessionStorage.removeItem("SPMS_CERTIFICATES")
                window.sessionStorage.removeItem("SPMS_SIGNATURE")
                window.sessionStorage.removeItem("SPMS_AUTH_TYPE")

                if(event.data)
                    event.data()

                bootbox.alert(GlobalTranslations['APP_LABEL.PEM.SPMS_AUTH_FAIL'])

                $('#contextual-buttons button.print_btn').attr('disabled', false);

                $('#contextual-buttons button.confirm_btn').attr('disabled', false);

                return false
            });
    },
    goToPrescriptionScreen: function(params, response){
        console.log("response", response.status)
        // response = JSON.parse(response);

        if (response.status === "success"){
            response=response|{}
            external_medication.professional_card_data = response.data;

            var send_params = external_medication.goToPrescriptionScreenStrategyInfo;

            Hades.loadScreen(params.screen_rsp_path, send_params);

            external_medication.goToPrescriptionScreenStrategyInfo = null;

        }else{
            Hades.hideLoading();

            $('#contextual-buttons button.print_btn').attr('disabled', false);
            $('#contextual-buttons button.confirm_btn').attr('disabled', false);

            var error_msg = '';
            if (response.status === "ERR_CONNECTION_REFUSED"){
                error_msg = 'ERR_CONNECTION_REFUSED';
            }else if (response.status === "error"){
                error_msg = GlobalTranslations['APP_LABEL.2169'];
            } else{
                error_msg = response.data.error_msg ? response.data.error_msg + ' ' : GlobalTranslations['APP_LABEL.2169'];
            }

            bootbox.alert(error_msg);

            /*bootbox.confirm(error_msg + GlobalTranslations['APP_LABEL.2170'], function(result){
                debug.log(result);
                if (result){
                    //read card error, reaload to materialized in confirm option
                    Hades.loadScreen(params.screen_rx_path);
                }
            });*/

        }
        //}
    },

    /**********************************
     * PEM - GENERAL EVENTS / VALIDATIONS
     **********************************/
    getPEMConfigs: function (){
        external_medication.pem_configs = {
            request_id: null,
            url_path: ('http://localhost:8081/app/authws/getCertificates'),
            screen_rsp_path: '/prescription/external_medication/index_dematerialized',
            screen_rx_path: '/prescription/external_medication/index'
        };

        $.getJSON('/prescription/external_medication/get_pem_configs', null)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                external_medication.pem_configs = {
                    configs_list: data,
                    request_id: null,
                    //url_path: ('http://localhost:' + data[0].web_service_auth_cc_port + '/app/authws/validate'),
                    url_path: (data[0].web_service_card_auth_endpoint),
                    screen_rsp_path: '/prescription/external_medication/index_dematerialized', // data[0].screen_path
                    screen_rx_path: '/prescription/external_medication/index' // ((data[1] && (data[1].id == 2 || data[1].id == 3)) ? data[1].screen_path : '')
                };

            })
            .fail(function (xhr, status, error) {
                $('#contextual-buttons button.print_btn').attr('disabled', false);
                $('#contextual-buttons button.confirm_btn').attr('disabled', false);
            });
    },

    validateInfoModal: function (params){
        //init PEM configs
        external_medication.getPEMConfigs();

        $.get('/prescription/external_medication/validate_info_header_modal', params || {}, null, 'html')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    $('#contextual-buttons button.print_btn').attr('disabled', false);
                    $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                    Hades.showError(data.error, xhr.responseText, xhr, status, data.error);
                    Hades.hideLoading();
                } else {
                    Hades.hideLoading();
                }


                $('#validate-info-header-modal-ct').on('OnConfirmClickButton', external_medication.afterModalConfirmButton);

            })
            .fail(function (xhr, status, error) {
                $('#contextual-buttons button.print_btn').attr('disabled', false);
                $('#contextual-buttons button.confirm_btn').attr('disabled', false);
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },

    afterModalConfirmButton: function (e,username,password, isUE, remainInPage, callback) {

        $.fancybox.close();

        var params = external_medication.goToPrescriptionScreenStrategyInfo;

        if (external_medication.goToPrescriptionScreenStrategyInfo.id == 1 /*parseInt('<%= GlobalConstants::PEM_REGISTER_SERVICE_CONFIG_DEMATERIALIZED %>')*/ ) {
            if(!window.sessionStorage.getItem("SPMS_TOKEN"))
                external_medication.autenticateCC(remainInPage);
            else
                external_medication.alreadyAuthenticated()

        }else{

            if(!window.sessionStorage.getItem("SPMS_TOKEN") && !window.sessionStorage.getItem("SPMS_AUTH_TYPE")){
                external_medication.getSPMSTokenCredentials(isUE, username, password, remainInPage)
            }else {
                external_medication.alreadyAuthenticated(isUE)
            }
        }

    },

    alreadyAuthenticated: function(isUE){
        var params = {}
        params.financial_institution_id = $('#financial_institution').val()
        params.isUE = isUE
        Hades.loadScreen(external_medication.goToPrescriptionScreenStrategyInfo.screen_path, params)
        external_medication.goToPrescriptionScreenStrategyInfo = null
    },

    autenticateCC: function(remainInPage, callback){
        var params = {
            request_id: null,
            url_path: external_medication.pem_configs.url_path,
            screen_rsp_path: external_medication.pem_configs.screen_rsp_path,
            screen_rx_path: external_medication.pem_configs.screen_rx_path
        };

        external_medication.autenticatePersonalCard(params, callback, remainInPage);
    },

    goToMaterializedPrescrition: function(prescriptionList, offline, financial_institution){
        external_medication.offlinePrescription = offline;

        external_medication.prescriptionList = prescriptionList;

        var params = {
            financial_institution_id: financial_institution
        };

        Hades.loadScreen('/prescription/external_medication/index', params);
    },

    validatePatientPrescriptionInfo: function(params, callback){

        $.get('/prescription/external_medication/validate_dematerialized_sns_fi', params, null, "json")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                callback(data);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();

            });

    },

    validateSpecificInn: function(){
        if ( typeof(prescription_external_medication_index) !== 'undefined' ){
            prescription_external_medication_index.currentMedicament.not_neuropatic_pain = true;
        }else{
            prescription_external_medication_index_dematerialized.currentMedicament.not_neuropatic_pain = true;
        }
        return true;
    },

    addNeuropaticPatientPathologie: function () {

        var params = {
            special_pathology_id: 40, // CFT 2.10  -- special_pathology_id,
            pathology_description: null //pathology_description
        };

        $.post('/prescription/external_medication/add_patient_pathology', params, null, "json")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if(data.success) {
                    $('#directions_outer_ct').hide();
                    Hades.loadPartial('/prescription/external_medication/search_medication_screen', {search_type: 'BRAND'}, 'search_medication_outer_ct', external_medication.validateSpecificInnToBrandSearch);
                } else {
                    Hades.showBalloonMessage(data.error, 'alert-error', 2000);
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showBalloonMessage(error, 'alert-error', 2000);
                Hades.hideLoading();
            });


    },
    validateSpecificInnToBrandSearch: function(){
        async: false;

        external_medication.onSearchTypeNavClick();

        var params = {};
        if ( typeof(prescription_external_medication_index) !== 'undefined' ){
            params = prescription_external_medication_index.currentMedicament;
        }else{
            params = prescription_external_medication_index_dematerialized.currentMedicament;
        }

        $.getJSON('/prescription/external_medication/get_related_inn_product_specific_insdustrial_rigths', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if(data.success){
                    async: false;

                    data.result.pkg_size_id = data.result.package_size;

                    var ds = {
                        package_id: data.result.package_id,
                        package_supplier_id: data.result.package_supplier_id,
                        pm_desc: data.result.product_desc,
                        pharm_form_id: data.result.pharm_form,
                        pharm_form_desc: data.result.pharm_form_desc,
                        strength_id: data.result.strength,
                        strength_desc: data.result.strength_desc,
                        pkg_size_id: data.result.package_size,
                        pkg_size_desc: data.result.pkg_size_desc
                    };

                    if ( typeof(prescription_external_medication_index) !== 'undefined' ){
                        prescription_external_medication_index.updateBrandFields(false, ds);
                    }else{
                        prescription_external_medication_index_dematerialized.updateBrandFields(false, ds);
                    }

                    //prescription_external_medication_index.currentMedicament.searchOption = 'BRAND';
                    //prescription_external_medication_index.currentMedicament.justification_id = 'C';
                    //prescription_external_medication_index.currentMedicament.justification_supplier_id = 'IM';

                    //debug.log(prescription_external_medication_index.currentMedicament);

                    $('#brand_desc').blur();

                    external_medication.onSearchTypeBrand();

                } else {
                    async: false;

                    if ( typeof(prescription_external_medication_index) !== 'undefined' ){

                        prescription_external_medication_index.searchBrand();
                    }else{
                        prescription_external_medication_index_dematerialized.searchBrand();
                    }

                    $('#brand_desc').blur();

                    external_medication.onSearchTypeBrand();

                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    }
};
